import React from 'react';

const Skillset = ({ skills }) => {
  React.useEffect(() => {
    document.addEventListener('scroll', (e) => {
      const ele = document.querySelector('.skill-set');
      if (ele) {
        const value = ele.getBoundingClientRect().y;
        if (value < window.scrollY) {
          ele.classList.add('active-section');
        } else {
          ele.classList.remove('active-section');
        }
      }
    });
  }, []);

  return (
    <div className="skill-set">
      {skills.map((skill) => (
        <div className="bar" key={skill.id}>
          <div className="label">{skill.label}:</div>
          <div className="width-parent" style={{ width: skill.width }}>
            <div className="width">
              {' '}
              <span className="value">{skill.value}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skillset;
